import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "..";
import { GET_ALL_BIOMETRIC } from "../Queries/biometric";
import { setLoader } from "./loaderSlice";

export const EsslData = createAsyncThunk(
  "essl/fetchData",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoader(true));

      const { data } = await client.query({
        query: GET_ALL_BIOMETRIC,
        variables: {
          ...payload,
          page: payload.page || 1,
          pageSize: payload.pageSize || 50,
        },
        fetchPolicy: "network-only",
      });

      return data.getAllBiometric; // returns { totalCount, records }
    } catch (error) {
      return rejectWithValue(error.message);
    } finally {
      dispatch(setLoader(false));
    }
  }
);

const esslDataSlice = createSlice({
  name: "essl",
  initialState: {
    biometric: {
      records: [],
      totalCount: 0,
    },
  },
  reducers: {
    setBiometric(state, action) {
      state.biometric = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(EsslData.fulfilled, (state, action) => {
      state.biometric = action.payload;
    });
  },
});

export const { setBiometric } = esslDataSlice.actions;
export default esslDataSlice.reducer;
